import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import { Home } from './home/home_page';
import { updateState, fetchStates } from "./api"; 
import { useEffect } from "react";
function App() {
  useEffect(_=>{
	  fetchStates().then(data => {
                updateState({...data, vistors: String(+data.vistors + 1)});   
	  });
  }, []);
  return (
    <div className="App">
          <Router>
            <Routes>
              <Route path="*" element={ <Home/> }/>
            </Routes>
          </Router>
    </div>
  );
}
export default App;
